export const addScopeToSentry = (sentry, userInfo) => {
  const apiUrl = import.meta.env.VITE_API_URL;
  const clientVersion = import.meta.env.VITE_VERSION;
  const websiteType = import.meta.env.VITE_WEBSITE_TYPE;

  let environment = 'development';
  if (apiUrl.includes('staging')) environment = 'staging';
  else environment = 'production';

  const clientInfo = {
    clientVersion,
    websiteType,
    environment,
  };

  sentry.setUser(userInfo);
  sentry.setExtra('clientInfo', clientInfo);
};
